export const NAVIGATION_TYPE = {
  MAIN_PAGE             : 'main_page',
  INSPIRED_LOOKS_PAGE   : 'inspired_looks_page',
  FAVOURITE_BRANDS_PAGE : 'favourite_brands_page'
}

export const SECTION = {
  HIGHLIGHT       : 'highlight',
  RECENTLY_LIVE   : 'recently_live',
  RELATED_ARTICLE : 'related_article'
}
